import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isNavExpanded: false,
  isLoading: false,
  theme: {
    selected: "dark",
  },
};

const publicSlice = createSlice({
  name: "public",
  initialState: initialState,
  reducers: {
    toggleHamburger(state, action) {
      state.isNavExpanded = action.payload;
    },
    isLoading(state, action) {
      state.isLoading = action.payload;
      //console.log(action)
    },
    changeTheme(state, action) {
      // console.log(state.theme.selected)
      state.theme.selected = action.payload;
      localStorage.setItem("theme", action.payload);
    },
    getNotification(state, action) {
      state.notification = action.payload.response.data;
    },
    alert(state, action) {
      state.error = action.payload;
    },
  },
});

export default publicSlice.reducer;
export const publicActions = publicSlice.actions;
